import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=5284d4d4&scoped=true&"
import script from "./Template.vue?vue&type=script&lang=js&"
export * from "./Template.vue?vue&type=script&lang=js&"
import style0 from "./Template.vue?vue&type=style&index=0&id=5284d4d4&scoped=true&lang=css&"
import style1 from "./Template.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5284d4d4",
  null
  
)

export default component.exports